import {
  Directive, ElementRef, Input, Output, EventEmitter,
  OnInit, OnDestroy, forwardRef
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

declare var intlTelInput: any;

@Directive({
  selector: '[ng2TelInput]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => Ng2TelInputDirective),
    multi: true
  }]
})
export class Ng2TelInputDirective implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() ng2TelInputOptions: any = {};
  @Output() intlTelInputObject = new EventEmitter<any>();
  @Output() ng2TelOutput = new EventEmitter<string>();
  @Output() countryChange = new EventEmitter<any>();
  @Output() hasError = new EventEmitter<boolean>();

  private telInput: any;
  private onChange: any = () => {};
  private onTouched: any = () => {};

  constructor(private el: ElementRef) {}

  ngOnInit() {
    const options = {
      initialCountry: 'in',
      separateDialCode: false,
      ...this.ng2TelInputOptions
    };

    if (typeof intlTelInput !== 'undefined') {
      this.telInput = intlTelInput(this.el.nativeElement, options);
      this.intlTelInputObject.emit(this.telInput);

      this.el.nativeElement.addEventListener('countrychange', () => {
        const data = this.telInput.getSelectedCountryData();
        this.countryChange.emit(data);
      });

      this.el.nativeElement.addEventListener('input', () => {
        const val = this.el.nativeElement.value;
        this.onChange(val);
        this.ng2TelOutput.emit(val);
        this.hasError.emit(this.telInput.isValidNumber());
      });

      this.el.nativeElement.addEventListener('blur', () => {
        this.onTouched();
      });
    }
  }

  ngOnDestroy() {
    if (this.telInput) {
      this.telInput.destroy();
    }
  }

  writeValue(value: any): void {
    if (value && this.el.nativeElement) {
      this.el.nativeElement.value = value;
      if (this.telInput) {
        this.telInput.setNumber(value);
      }
    }
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }

  getNumber(): string {
    return this.telInput ? this.telInput.getNumber() : this.el.nativeElement.value;
  }

  isValidNumber(): boolean {
    return this.telInput ? this.telInput.isValidNumber() : false;
  }

  getSelectedCountryData(): any {
    return this.telInput ? this.telInput.getSelectedCountryData() : {};
  }

  setCountry(country: string): void {
    if (this.telInput) this.telInput.setCountry(country);
  }
}
